import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * JWT Interceptor
 *
 * - Adjunta automáticamente el token a TODAS las peticiones HTTP
 * - Maneja errores 401 de forma global
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = localStorage.getItem('kpi_token');

  // Si no hay token (login, forgot-password, etc.)
  if (!token) {
    return next(req);
  }

  // Clonar request con Authorization header
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      /**
       * 401 = sesión inválida
       * - token expirado
       * - usuario desactivado
       * - JWT inválido
       */
      if (error.status === 401) {
        auth.logout();
      }

      return throwError(() => error);
    }),
  );
};
